module.exports = __webpack_public_path__ + "img/1041891186.57cc33d4.jpg";